import React, { ReactElement, ReactNode } from 'react';

import { Chip } from '@mui/material';

import { primary_text_color } from 'theme/cemTheme';

import { classNames } from './utils';

import styles from './common.module.css';

export interface IStlChip {
  icon?: ReactElement;
  label: string;
  strokeWidth?: number;
  color: {
    bg: string;
    icon?: string;
    text?: string;
  };
}

export default function StlChip({ icon, label, color, strokeWidth }: IStlChip) {
  return (
    <Chip
      icon={icon}
      label={label}
      sx={{
        color: color.text || primary_text_color,
        backgroundColor: color.bg,
        '& .MuiChip-label': {
          fontSize: '12px',
        },
        '& .MuiChip-icon': {
          fontSize: '8px',
          stroke: color.icon,
          color: color.icon,
          strokeWidth: strokeWidth || '1.2',
        },
      }}
      size="small"
    />
  );
}

interface IStlAvatarChip {
  txt: ReactNode;
  handleClick?: () => void;
  avatar?: ReactElement;
  classes?: string[];
  active?: boolean;
}

export function StlAvatarChip({
  txt,
  avatar,
  handleClick,
  classes = [],
  active = false,
}: IStlAvatarChip) {
  return (
    <Chip
      label={txt}
      onClick={handleClick}
      avatar={avatar}
      className={classNames(
        styles.avatar_chip,
        active && styles.active,
        ...classes,
      )}
    />
  );
}
